module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/features/buttons/floated-buttons/floated-buttons.component.scss
// module id = ./src/app/features/buttons/floated-buttons/floated-buttons.component.scss
// module chunks = main